import { render, staticRenderFns } from "./checkDetails.vue?vue&type=template&id=a98e20c4&scoped=true&"
import script from "./checkDetails.vue?vue&type=script&lang=js&"
export * from "./checkDetails.vue?vue&type=script&lang=js&"
import style0 from "./checkDetails.vue?vue&type=style&index=0&id=a98e20c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e20c4",
  null
  
)

export default component.exports